import cn from 'clsx'
import s from './AboutpageHero.module.scss'
import { FC } from 'react'
import { FullHeightSection, Text, CustomImage, Container } from '@components/ui'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'
import { AboutpageAboutPageHero as AboutpageHeroType } from '@generated/model/models'

type AboutpageHeroProps = {
  data?: AboutpageHeroType
  children?: any
  id: string
}

const AboutpageHero: FC<AboutpageHeroProps> = ({ data, children, id }) => {
  return (
    <>
      <FullHeightSection
        className={s.root}
        image={data as CustomImageProps}
        imageClassName={s.image}
        slideIndex={0}
        id={id}
      >
        
        <Text html={data?.title} className={s.title} variant="pageHeading" />
        <Text html={data?.detail} className={s.detail} variant="smallText" />
      </FullHeightSection>
    </>
  )
}

export default AboutpageHero
